import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react"
import { useCallback, useContext, useRef } from "react"
import BookNav from "./BookNav"
import { XMarkIcon } from "@heroicons/react/20/solid"
import { classNames } from "../lib"
import { BookNavModalContext } from "./Contexts"

const BookNavModal = () => {
  const { setIsOpen, isOpen } = useContext(BookNavModalContext)
  const ref = useRef<HTMLDivElement>(null)
  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <Transition show={isOpen}>
      <Dialog onClose={closeModal} as="div" className="fixed inset-0 z-30" initialFocus={ref}>
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 hidden bg-black/10 backdrop-blur-sm sm:block" />
        </TransitionChild>

        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <DialogPanel
            className={classNames(
              "prose prose-sm prose-a:no-underline opacity-100",
              "z-20 w-full bg-white font-sans text-base ring-1 ring-black/5",
              "sm:absolute sm:left-1/2 sm:top-8 sm:-ml-48 sm:h-[80vh] sm:w-96 sm:rounded-2xl sm:shadow-lg"
            )}
          >
            <DialogTitle as="div" className="flex justify-center">
              <h2 className="!mt-7 text-center text-2xl font-normal text-sky-700">
                Read the Bible
              </h2>
              <button
                type="button"
                className={classNames(
                  "absolute right-7 top-6 sm:top-7 inline-flex justify-center rounded-md",
                  "border border-transparent p-1 text-sm",
                  "font-medium text-blue-900 hover:bg-blue-200",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                )}
                onClick={closeModal}
              >
                <XMarkIcon className="size-6" />
                <span className="sr-only">Close</span>
              </button>
            </DialogTitle>
            <BookNav ref={ref} />
          </DialogPanel>
        </TransitionChild>
      </Dialog>
    </Transition>
  )
}

export default BookNavModal
